import React from 'react'
import Slider from 'react-slick'

const CustomSlider = ({ onNextClick, page, children, id, visitSlide, setVisitSlide }) => {
  const SampleNextArrow = (props) => {
    const { className, onClick, currentSlide } = props
    return (
      <div
        className={className}
        onClick={() => {
          if (!className?.includes('slick-disabled')) {
            onClick()
            setVisitSlide(currentSlide)
            if (visitSlide <= currentSlide) {
              onNextClick(id, page + 1)
            }
          }
        }}
      />
    )
  }

  const SamplePrevArrow = (props) => {
    const { className, onClick } = props
    return (
      <div
        className={className}
        onClick={() => {
          if (!className?.includes('slick-disabled')) {
            onClick()
          }
        }}
      />
    )
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide: false,
    lazyLoad: true,
    draggable: false,
    swipe:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ],
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  }

  return <Slider {...settings}>{children}</Slider>
}
export default CustomSlider
